module.exports = __webpack_public_path__ + "img/icon_sm_cgrk.6d0aa754.png";